import { render, staticRenderFns } from "./projektmanagement-6-2.vue?vue&type=template&id=6f7699f2&"
import script from "./projektmanagement-6-2.vue?vue&type=script&lang=js&"
export * from "./projektmanagement-6-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports